import { RendererFactory2, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { Logger } from '@frontend/vanilla/core';
import { filter } from 'rxjs';

import { VIEW_TRANSITION_LOG_TAG as LOG_TAG, NAVIGATION_HAS_NATIVE_TRANSITION_MESSAGE } from '../../view-transition.constants';
import { NativeTransitionDetectionStrategy } from './model/native-transition-detection.strategy.model';

export class HistoryApiNativeTransitionDetectionStrategy implements NativeTransitionDetectionStrategy {
    readonly #logger = inject(Logger);
    readonly #router = inject(Router);
    readonly #renderer = inject(RendererFactory2).createRenderer(null, null);

    #navigationHasNativeTransition = false;

    get navigationHasNativeTransition(): boolean {
        return this.#navigationHasNativeTransition;
    }

    init(): this {
        this.listenForNativeTransitions();

        return this;
    }

    private listenForNativeTransitions(): void {
        this.#renderer.listen('window', 'popstate', (event: PopStateEvent) => {
            const hasUAVisualTransition = event.hasUAVisualTransition;

            if (hasUAVisualTransition) {
                this.#logger.info(`${LOG_TAG} ${NAVIGATION_HAS_NATIVE_TRANSITION_MESSAGE}`);
            }

            this.#navigationHasNativeTransition = hasUAVisualTransition;
        });

        // Must be reset after each navigation as it is only set on a subset of navigations (popstate)
        this.#router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => (this.#navigationHasNativeTransition = false));
    }
}
